import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

const useGetVerificationEmail = () => {
  const preferredEmail = useEmployeeStore((state) => state.employee?.employerProvidedEmail);
  return preferredEmail;
};

export default useGetVerificationEmail;
